import React from "react";
import TargetAnimalsDetail from "./TargetAnimalsDetail";
import TargetCropsDetail from "./TargetCropsDetail";

const TargetIndex = ({ base, data,storeId, productId }) => {
  return (
    <>
      {base !== "MACHINERY" &&
      base !== "SEEDS" &&
      base === "FEED_SUPPLEMENT" ? (
        <TargetAnimalsDetail productbase={base} detail={data} productId={productId}/>
      ) : (
        <TargetCropsDetail productbase={base} detail={data} storeId={storeId} productId={productId}/>
      )}
    </>
  );
};

export default TargetIndex;
